import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CardGridViewModel } from '../../card-grid/card-grid-view-model';
import { MarketingHeaderComponent } from '../marketing-header.component';
import type { Card } from '../../../../../../../../models/menu/product-menu-cards/card';
import type { MarketingComboMenu } from '../../../../../../../../models/menu/marketing/marketing-combo-menu';

@Component({
  selector: 'app-combo-header',
  templateUrl: './combo-header.component.html',
  providers: [CardGridViewModel, [{ provide: MarketingHeaderComponent, useExisting: ComboHeaderComponent }]],
  standalone: false
})
export class ComboHeaderComponent extends MarketingHeaderComponent implements OnInit, OnChanges {
  constructor(public viewModel: CardGridViewModel) {
    super();
  }

  @Input() menu: MarketingComboMenu;
  @Input() cards: Card[] = [];

  ngOnInit(): void {
    this.viewModel.connectToCards(this.cards);
    this.viewModel.connectToMenu(this.menu);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cards) this.viewModel.connectToCards(this.cards);
    if (changes.menu) this.viewModel.connectToMenu(this.menu);
  }
}
